import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { toast } from "@/components/ui/sonner";
import { Bridge, ArrowRight } from "@phosphor-icons/react";

const HERO = "https://images.pexels.com/photos/36733421/pexels-photo-36733421.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function Login() {
  const { login, homePath } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const u = await login(email.trim(), password);
      toast.success(`Welcome back, ${u.name}`);
      navigate(homePath(u));
    } catch (err) {
      setError(errMsg(err, "Invalid email or password"));
    } finally {
      setLoading(false);
    }
  };

  const quick = (e, p) => { setEmail(e); setPassword(p); };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img src={HERO} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#111827]/70" />
        <div className="relative p-12 h-full flex flex-col justify-between text-white">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-9 h-9 bg-[#002FA7] flex items-center justify-center"><Bridge size={22} weight="bold" color="#fff" /></div>
            <span className="font-display font-bold text-2xl">Rate<span className="text-[#7C93E6]">Bridge</span></span>
          </Link>
          <div>
            <h2 className="font-display font-black text-4xl leading-tight">Direct hotel deals.<br />No middleman.</h2>
            <p className="text-white/70 mt-4 max-w-sm">Sign in to manage RFPs, negotiations, contracts, prospecting and your sales pipeline.</p>
          </div>
          <div />
        </div>
      </div>

      <div className="flex items-center justify-center p-6">
        <div className="w-full max-w-sm">
          <Link to="/" className="lg:hidden flex items-center gap-2 mb-8">
            <div className="w-8 h-8 bg-[#002FA7] flex items-center justify-center"><Bridge size={20} weight="bold" color="#fff" /></div>
            <span className="font-display font-bold text-xl">RateBridge</span>
          </Link>
          <span className="overline text-[#002FA7]">Sign in</span>
          <h1 className="font-display font-black text-4xl text-[#111827] mt-2">Welcome back.</h1>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <label className="block text-sm">
              <span className="overline text-[#4B5563] block mb-1">Email</span>
              <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full border border-[#E5E7EB] px-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-[#002FA7]" />
            </label>
            <label className="block text-sm">
              <span className="overline text-[#4B5563] block mb-1">Password</span>
              <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full border border-[#E5E7EB] px-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-[#002FA7]" />
            </label>
            {error && <div data-testid="login-error" className="bg-[#FEE2E2] text-[#B91C1C] text-sm px-3 py-2">{error}</div>}
            <button data-testid="login-submit" type="submit" disabled={loading}
              className="w-full bg-[#002FA7] text-white py-3 font-semibold hover:bg-[#00227A] transition-colors active:scale-[0.98] disabled:opacity-60 flex items-center justify-center gap-2">
              {loading ? "Signing in…" : "Sign in"} <ArrowRight size={18} weight="bold" />
            </button>
          </form>

          <p className="text-sm text-[#4B5563] mt-6">
            No account? <Link to="/register" data-testid="to-register" className="text-[#002FA7] font-semibold hover:underline">Create one</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
